module.exports = __webpack_public_path__ + "img/8.3b31895a.jpg";